import {
  createI18nMessage,
  maxLength,
  minLength,
  numeric,
  required,
} from '@vuelidate/validators';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { useI18n } from 'vue-i18n';
import { zodEmailValidator } from '@/utils/emailValidation';

// Get validation rules for form fields
export function useAmbassadorSignupValidation() {
  const { t } = useI18n({ useScope: 'global' });
  const withI18nMessage = createI18nMessage({ t });

  return {
    email: {
      required: withI18nMessage(required, {
        messagePath: () => t('helperOnboarding.email.error'),
      }),
      email: withI18nMessage(zodEmailValidator, {
        messagePath: () => t('validation.invalidEmail'),
      }),
    },
    phoneNumber: {
      required: withI18nMessage(required, {
        messagePath: () => t('validation.value'),
      }),
      validPhoneNumber: withI18nMessage(
        (value: string) => isValidPhoneNumber(value),
        {
          messagePath: () => t('generic.phoneNumber') + t('validation.valid'),
        }
      ),
    },
    code: {
      required: withI18nMessage(required, {
        messagePath: () => t('validation.value'),
      }),
      minLength: withI18nMessage(minLength(6), {
        messagePath: () => t('validation.codeLength'),
      }),
      maxLength: maxLength(6),
      numeric,
    },
    firstname: {
      required: withI18nMessage(required, {
        messagePath: () => t('helperOnboarding.name.errorFirstName'),
      }),
    },
    lastname: {
      required: withI18nMessage(required, {
        messagePath: () => t('helperOnboarding.name.errorLastName'),
      }),
    },
    profilePicture: {
      size: withI18nMessage(
        (value: File | null) => {
          if (!value) return true;

          if (value instanceof File && typeof value.size === 'number') {
            return value.size < 9 * 1000 * 1000;
          }
          return true;
        },
        {
          messagePath: () => t('validation.pictureSize'),
        }
      ),
    },
    position: {
      maxLength: withI18nMessage(maxLength(50), {
        messagePath: () => t('validation.maxLength50'),
      }),
    },
    address: {
      // Address is optional, no validation needed
    },
    language: {
      // Language has default value, no validation needed
    },
    actionsInterestedIn: {
      // Actions are pre-selected, but we could add minLength if needed
      // minLength: withI18nMessage(minLength(1), {
      //   messagePath: () => t('validation.selectAtLeastOne'),
      // }),
    },
    userTouchPoints: {
      $each: {
        value: {
          required: withI18nMessage(required, {
            messagePath: () => t('validation.required'),
          }),
        },
      },
    },
  };
}
